import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { whatsappUrl } from '../content/siteContent';

const { FiCoffee, FiShoppingCart, FiPlusSquare, FiPackage, FiFileText, FiNavigation, FiArrowUpRight } = FiIcons;

const services = [
  [FiCoffee, 'Comida', 'Recogemos pedidos en restaurantes, cafeterías y negocios de Bonao.'],
  [FiShoppingCart, 'Supermercados y colmados', 'Hacemos tus compras y te las llevamos.'],
  [FiPlusSquare, 'Farmacias', 'Recogemos tus productos en la farmacia que prefieras.'],
  [FiPackage, 'Paquetes', 'Recogida y entrega de paquetes dentro de nuestras zonas de servicio.'],
  [FiFileText, 'Documentos', 'Traslado rápido de documentos y sobres.'],
  [FiNavigation, 'Diligencias', 'Si necesitas buscar, llevar o recoger algo, mándanos a nosotros.']
];

function Services() {
  return (
    <section className="services section" id="servicios">
      <div className="container services__layout">
        <div className="section-heading services__heading">
          <span className="eyebrow">Resolvemos por ti</span>
          <h2>Mucho más que <em>delivery.</em></h2>
          <p>Estamos para ayudarte a resolver esas diligencias que te quitan tiempo.</p>
          <a className="text-link" href={whatsappUrl()} target="_blank" rel="noreferrer">
            Solicitar un servicio <SafeIcon icon={FiArrowUpRight} />
          </a>
        </div>
        <div className="services__grid">
          {services.map(([icon, title, text], index) => (
            <motion.article
              className="service-card"
              key={title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
            >
              <span className="service-card__number">0{index + 1}</span>
              <span className="service-card__icon"><SafeIcon icon={icon} /></span>
              <h3>{title}</h3>
              <p>{text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;